import React from 'react';
import { useSelector } from 'react-redux';

import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { NotificationsList } from '../../components/notifications/NotificationsList';
import { NotificationsBreadcrumb } from '../../components/notifications/NotificationsBreadcrumb';

export const NotificationsPage = () => {
    useDocumentTitle('Notifications');

    const { notifications } = useSelector((state) => state.ui);

    return (
        <div className="notifications-page mb-5">
            <h1 className="h3">Notifications</h1>
            <NotificationsBreadcrumb />
            <NotificationsList notifications={notifications} />
        </div>
    );
};
